<template>
    <div v-if="!this.params.data.is_roomtype">
        <div class="ecallinks-wrapper" v-for="link in value">
            <span class="ecallink">{{link.url}}</span>
            <b-button
                class="align-baseline mb-1"
                title="Remove external calendar"
                variant="default"
                @click="onShowRemoveUrlModal(link.id)"
            >
                <font-awesome-icon :icon="['fas', 'minus']"></font-awesome-icon>
            </b-button>
            <b-button
                v-if="link.url.length > 40"
                class="align-baseline ml-1 mb-1"
                title="Show URL"
                variant="default"
                @click="onShowCurrentUrlModal(link.id, link.url)"
            >
                <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>
            </b-button>
        </div>
        <b-button
            class="align-baseline d-flex align-items-center"
            title="Add external calendar"
            variant="default"
            @click="onShowAddUrlModal"
        >
            <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
            <span class="d-none d-md-block d-lg-block ml-1">Add URL</span>
        </b-button>
        <modal
            v-if="showUrlModalId"
            :id="showUrlModalId"
            title="ICal Import URL"
            :ok-only="true"
        >
            <div>
                <span class="w-100 showing-url">
                    {{currentDisplayingUrl}}
                </span>
            </div>
        </modal>
        <modal
            v-if="removeUrlModalId"
            :id="removeUrlModalId"
            title="Delete iCal URL"
            @ok="onRemoveUrl"
        >
            Deleting an iCalendar feed will remove all calendar blocks associated with this feed, would you like to continue?
        </modal>
        <validation-observer v-slot="{ meta }">
            <modal
                v-if="addrUrlModalId"
                :id="addrUrlModalId"
                title="Add External iCalendar"
                ok-title="Add iCalendar"
                :ok-disabled="!meta.valid"
                @ok.prevent="onAddUrl"
            >
                <div class="w-75">
                    <validation-provider name="url" v-slot="{ errors, handleChange }" rules="required" >
                        <form-input
                            floating-label="URL:"
                            v-model="newUrl"
                            :error="errors[0]"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                </div>
            </modal>
        </validation-observer>
    </div>
</template>

<script>
    import ResponsiveButton from '../generic/responsive-button/responsive-button.vue';
    import API from '../../api';
    import Modal from '../generic/modal/modal.vue';
    import FormInput from '../generic/form-input/form-input.vue';
    import FormSelect from '../generic/form-select/form-select.vue';
    import {ICALENDAR_DELETE_ICAL_IMPORT_URL_ENDPOINT, ICALENDAR_ADD_ICAL_IMPORT_URL_ENDPOINT} from '../../endpoints'

    export default {
        components: {
            ResponsiveButton,
            Modal,
            FormInput,
            FormSelect
        },
        data() {
            return {
                value: [],
                removeUrlModalId: null,
                addrUrlModalId: null,
                newUrl: null,
                showUrlModalId: null,
                currentDisplayingUrl: null,
            }
        },
        created() {
            this.value = this.params.value;
        },
        methods: {
            onShowAddUrlModal() {
                this.addrUrlModalId = this.params.data.id.toString()
                this.$nextTick(() => {
                    this.$bvModal.show(this.addrUrlModalId)
                })
            },
            onShowCurrentUrlModal(id, url) {
                this.showUrlModalId = id.toString();
                this.currentDisplayingUrl = url;
                this.$nextTick(() => {
                    this.$bvModal.show(this.showUrlModalId)
                })
            },
            onShowRemoveUrlModal(id) {
                this.removeUrlModalId = id.toString();
                this.$nextTick(() => {
                    this.$bvModal.show(this.removeUrlModalId)
                })
            },
            async onAddUrl() {
                try {
                    await API.post(ICALENDAR_ADD_ICAL_IMPORT_URL_ENDPOINT(this.addrUrlModalId), {
                        id: this.addrUrlModalId,
                        url: this.newUrl
                    })
                    this.$nextTick(() => {
                        this.$bvModal.hide(this.addrUrlModalId);
                    })
                    await this.$store.dispatch('iCalendar/fetchUrls');
                } catch (e) {
                    this.errorToast({text: `Could not create URL.`})
                }
            },
            async onRemoveUrl() {
                try {
                    await API.post(ICALENDAR_DELETE_ICAL_IMPORT_URL_ENDPOINT(this.removeUrlModalId), {})
                    await this.$store.dispatch('iCalendar/fetchUrls');
                } catch (e) {
                    this.errorToast({text: `Could not update data.`})
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    .showing-url {
        word-wrap: break-word;
    }

    .ecallinks-wrapper {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .ecallink {
            max-width: 700px;
            text-overflow: ellipsis;
            overflow-x: hidden;
            margin-right: 10px;
        }
    }
    .vue-app-wrapper .remove_url {
        font-size: 10px !important;
        width: 40px;
        height: 20px;
        position: relative;
        z-index: 2;
        :deep(.lx-responsive-button-icon) {
            position: absolute;
            top: 3px;
            left: 14px;
        }
    }

</style>